function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M.315 72.2c21.888-21.858 47.951-39.548 76.893-51.772C106.15 8.204 137.97 1.445 171.37 1.445s65.22 6.76 94.161 18.983c28.943 12.224 55.006 29.914 76.894 51.771"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.315 84.509c21.888-21.858 47.951-39.547 76.893-51.77 28.942-12.225 60.761-18.985 94.161-18.985s65.22 6.76 94.161 18.985c28.943 12.223 55.006 29.912 76.894 51.77"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.315 96.818c21.888-21.857 47.951-39.547 76.893-51.77 28.942-12.225 60.761-18.985 94.161-18.985s65.22 6.76 94.161 18.985c28.943 12.223 55.006 29.913 76.894 51.77"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.315 109.128C22.203 87.27 48.266 69.58 77.208 57.358c28.942-12.225 60.761-18.985 94.161-18.985s65.22 6.76 94.161 18.985c28.943 12.223 55.006 29.912 76.894 51.77"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.315 121.437C22.203 99.58 48.266 81.89 77.208 69.667c28.942-12.225 60.761-18.985 94.161-18.985s65.22 6.76 94.161 18.985c28.943 12.223 55.006 29.913 76.894 51.77"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.315 133.746C22.203 111.89 48.266 94.2 77.208 81.976c28.942-12.225 60.761-18.984 94.161-18.984s65.22 6.76 94.161 18.984c28.943 12.224 55.006 29.913 76.894 51.77"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.315 146.056c21.888-21.858 47.951-39.547 76.893-51.77C106.15 82.06 137.97 75.3 171.37 75.3s65.22 6.76 94.161 18.985c28.943 12.223 55.006 29.912 76.894 51.77"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.315 158.365c21.888-21.857 47.951-39.546 76.893-51.77C106.15 94.37 137.97 87.611 171.37 87.611s65.22 6.76 94.161 18.984c28.943 12.224 55.006 29.913 76.894 51.77"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.315 170.675c21.888-21.858 47.951-39.547 76.893-51.77C106.15 106.68 137.97 99.92 171.37 99.92s65.22 6.76 94.161 18.985c28.943 12.223 55.006 29.912 76.894 51.77"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.315 182.984c21.888-21.857 47.951-39.547 76.893-51.77 28.942-12.225 60.761-18.984 94.161-18.984s65.22 6.76 94.161 18.984c28.943 12.223 55.006 29.913 76.894 51.77"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.315 195.294c21.888-21.858 47.951-39.547 76.893-51.77 28.942-12.225 60.761-18.985 94.161-18.985s65.22 6.76 94.161 18.985c28.943 12.223 55.006 29.912 76.894 51.77"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.315 207.603c21.888-21.857 47.951-39.546 76.893-51.77 28.942-12.225 60.761-18.985 94.161-18.985s65.22 6.76 94.161 18.985c28.943 12.224 55.006 29.913 76.894 51.77"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.315 219.913c21.888-21.858 47.951-39.546 76.893-51.77 28.942-12.225 60.761-18.985 94.161-18.985s65.22 6.76 94.161 18.985c28.943 12.224 55.006 29.912 76.894 51.77"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 343 221"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

export default __webpack_public_path__ + "static/media/parallel-lines-3-mobile.0ba11fed.svg";
export { SvgComponent as ReactComponent };